import Box from "@/elements/Box";
import Typography from "@/elements/Typography";
import {
  Card,
  CardContent,
  FormControl,
  FormControlLabel,
  Paper,
  Radio,
  RadioGroup,
  Slide,
} from "@mui/material";
import { Control, Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { RichiestaPreventivoCreateDto, TipoOlioLavorazioni } from "@/api";

interface Step3TipoFluidoProps {
  activeStep: number;
  slideDirection: "left" | "right";
  control: Control<RichiestaPreventivoCreateDto>;
}

export function Step3TipoFluido({
  activeStep,
  slideDirection,
  control,
}: Step3TipoFluidoProps) {
  const { t } = useTranslation();

  return (
    <Slide
      direction={slideDirection}
      in={activeStep === 3}
      timeout={500}
      unmountOnExit
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          bgcolor: "white",
          position: activeStep === 3 ? "relative" : "absolute",
          width: "100%",
          top: 0,
        }}
      >
        <Box>
          <Typography variant="h5" gutterBottom mb={3} sx={{ color: "#333" }}>
            {t("richiestaPreventivo.step3.lavorazioni.tipoFluido")}
          </Typography>

          <FormControl component="fieldset" fullWidth>
            <Controller
              name="tipoOlioLavorazioni"
              control={control}
              rules={{
                required: t("richiestaPreventivo.step3.errors.required"),
              }}
              render={({ field }) => (
                <RadioGroup {...field}>
                  <Card
                    sx={{
                      mb: 2,
                      cursor: "pointer",
                      border: 2,
                      borderColor:
                        field.value === TipoOlioLavorazioni.lubrorefrigerante
                          ? "#667eea"
                          : "#e0e0e0",
                      bgcolor: "white",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        borderColor: "#667eea",
                        boxShadow: 2,
                      },
                    }}
                    onClick={() =>
                      field.onChange(TipoOlioLavorazioni.lubrorefrigerante)
                    }
                  >
                    <CardContent>
                      <FormControlLabel
                        value={TipoOlioLavorazioni.lubrorefrigerante}
                        control={<Radio />}
                        label={
                          <Box>
                            <Typography variant="h6" sx={{ color: "#333" }}>
                              {t(
                                "richiestaPreventivo.step3.lavorazioni.lubrorefrigerante",
                              )}
                            </Typography>
                          </Box>
                        }
                      />
                    </CardContent>
                  </Card>

                  <Card
                    sx={{
                      cursor: "pointer",
                      border: 2,
                      borderColor:
                        field.value === TipoOlioLavorazioni.olioIntero
                          ? "#667eea"
                          : "#e0e0e0",
                      bgcolor: "white",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        borderColor: "#667eea",
                        boxShadow: 2,
                      },
                    }}
                    onClick={() =>
                      field.onChange(TipoOlioLavorazioni.olioIntero)
                    }
                  >
                    <CardContent>
                      <FormControlLabel
                        value={TipoOlioLavorazioni.olioIntero}
                        control={<Radio />}
                        label={
                          <Box>
                            <Typography variant="h6" sx={{ color: "#333" }}>
                              {t(
                                "richiestaPreventivo.step3.lavorazioni.olioIntero",
                              )}
                            </Typography>
                          </Box>
                        }
                      />
                    </CardContent>
                  </Card>
                </RadioGroup>
              )}
            />
          </FormControl>
        </Box>
      </Paper>
    </Slide>
  );
}
